import React, { useEffect, useState } from "react";
import { postData, serverURL } from "../../services/NodeServices";
import "./Home.css"; // Ensure you have a CSS file for styling
import { useNavigate } from "react-router-dom";
import SliderSection from "../Swiper";
import CountdownTimer from "./CountDown";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Helmet } from "react-helmet";
import RatingDisplay from "../ReviewComp/ReviewComp";
import { List } from "react-admin";
import ProductList from "../../TailwindComponent/List/List";
import Newsletter from "../NewsLetter/NewsLetter";
import BannerSet from "../BannerSet/BannerSet";

const Home = () => {
  const navigate = useNavigate();

  const gettopProducts = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "men",
      productsubcategoryname: "T-shirt",
    });
    if (results.status) {
      SetTopProducts(results.data.reverse());
      setLoadingTopProducts(false);
    }
  };

  const gettopTrend = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "men",
      productsubcategoryname: "trend",
    });
    if (results.status) {
      SetTopProducts(results.data.reverse());
      setLoadingTopProducts(false);
    }
  };

  const getSweatshirt = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "men",
      productsubcategoryname: "Sweatshirt",
    });
    if (results.status) {
      setSweatShirt(results.data.reverse());
      setLoadingSweatShirt(false);
    }
  };

  const gettopProductsMan = async () => {
    const results = await postData("api/products/topman");
    if (results.status) {
      SetTopProductsMan(results.data.reverse().slice(0, 7));
      setLoadingTopProductsMan(false);
    }
  };
  const gettopProductsWomen = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "women",
      productsubcategoryname: "T-Shirts",
    });
    if (results.status) {
      SetTopProductsWomen(results.data);
      setLoadingTopProductsWomen(false);
      console.log(topProductsWomen);
    }
  };

  const gettopProductsKids = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "Kids",
      productsubcategoryname: "T-Shirts",
    });
    if (results.status) {
      setTopProductsKids(results.data);
      setLoadingTopKids(false);
    }
  };

  const gettopKidsHoodies = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "Kids",
      productsubcategoryname: "Hoodies",
    });
    if (results.status) {
      setTopKidsHoodies(results.data);
      setLoadingTopKidsHoodies(false);
    }
  };

  const gettopProductsHoodies = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "men",
      productsubcategoryname: "Hoodies",
    });
    if (results.status) {
      setTopProductsHoodies(results.data);
      setLoadingHoodies(false);
    }
  };

  const gettopShirtWomen = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "women",
      productsubcategoryname: "Sweatshirt",
    });
    if (results.status) {
      SetTopProductsWomen(results.data);
      setLoadingTopProductsWomen(false);
      console.log(topProductsWomen);
    }
  };

  const gettopShirtKids = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "Kids",
      productsubcategoryname: "Sweatshirt",
    });
    if (results.status) {
      setTopKidsShirt(results.data);
      setLoadingKidsShirt(false);
    }
  };
  const [topProducts, SetTopProducts] = useState([]);
  const [trending, setTrending] = useState([]);
  const [sweatShirt, setSweatShirt] = useState([]);

  const [topProductsMan, SetTopProductsMan] = useState([]);
  const [topProductsWomen, SetTopProductsWomen] = useState([]);
  const [topProductsKids, setTopProductsKids] = useState([]);

  const [loadingTopProducts, setLoadingTopProducts] = useState(true);
  const [loadingTopProductsMan, setLoadingTopProductsMan] = useState(true);
  const [loadingTopProductsWomen, setLoadingTopProductsWomen] = useState(true);
  const [loadingTopKids, setLoadingTopKids] = useState(true);
  const [loadingHoodies, setLoadingHoodies] = useState(false);

  const [loadingtrending, setLoadingTrending] = useState([]);
  const [loadingSweatShirt, setLoadingSweatShirt] = useState([]);

  const [topProductsHoodies, setTopProductsHoodies] = useState([]);

  const [topWomenTshirt, setTopWomenTshirt] = useState([]);
  const [topWomenHoodies, setTopWomenHoodies] = useState([]);
  const [topWomenSweatShirt, setTopWomenSweatShirt] = useState([]);

  const [topKidsShirt, setTopKidsShirt] = useState([]);

  const [loadingTopWomenTshirt, setLoadingTopWomenTshirt] = useState(true);
  const [loadingTopWomenHoodies, setLoadingTopWomenHoodies] = useState(true);
  const [loadingTopWomenSweatShirt, setLoadingTopWomenSweatShirt] =
    useState(true);

  const [loadingTopKidsShirt, setLoadingKidsShirt] = useState(true);

  const [topKidsHoodies, setTopKidsHoodies] = useState([]);

  const [loadingTopKidsTshirt, setLoadingTopKidsTshirt] = useState(true);
  const [loadingTopKidsHoodies, setLoadingTopKidsHoodies] = useState(true);
  const [loadingTopKidsSweatShirt, setLoadingTopKidsSweatShirt] =
    useState(true);

  const getTopWomenTshirt = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "women",
      productsubcategoryname: "T-Shirt",
    });
    if (results.status) {
      setTopWomenTshirt(results.data.reverse());
      setLoadingTopWomenTshirt(false);
    }
  };

  const getTopWomenHoodies = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "women",
      productsubcategoryname: "Hoodies",
    });
    if (results.status) {
      setTopWomenHoodies(results.data.reverse());
      setLoadingTopWomenHoodies(false);
    }
  };

  const getTopWomenSweatShirt = async () => {
    const results = await postData("api/products/topby", {
      productcategoryname: "women",
      productsubcategoryname: "Sweatshirt",
    });
    if (results.status) {
      setTopWomenSweatShirt(results.data.reverse());
      setLoadingTopWomenSweatShirt(false);
    }
  };

  useState(() => {
    gettopProducts();
    gettopProductsMan();
    gettopProductsWomen();
    gettopProductsKids();
    gettopProductsHoodies();
    getSweatshirt();
    getTopWomenTshirt();
    gettopShirtKids();
    getTopWomenHoodies();
    getTopWomenSweatShirt();

    gettopKidsHoodies();
  }, []);

  const handleProductClick = (product_id) => {
    const scrollY = window.scrollY;
    sessionStorage.setItem("scrollPosition", scrollY.toString());

    // Give time to write to sessionStorage
    setTimeout(() => {
      navigate(`/view/${product_id}`);
    }, 50); // 50ms delay to ensure storage
  };

  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");

    if (savedPosition) {
      /*   window.scrollTo({ top: parseInt(savedPosition), behavior: "auto " });
    sessionStorage.removeItem("scrollPosition"); // important */
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, []);

  const renderSkeletonCard = () => (
    <div className="col-md-3 col-6">
      <div className="firstsection_card">
        <Skeleton height={200} />
        <Skeleton width={`80%`} />
        <Skeleton width={`60%`} />
      </div>
    </div>
  );

  const test = () => {
    console.log("local result is", localStorage.getItem("user"));
  };

  return (
    <>
      <SliderSection />

      {/* First Section */}

      <BannerSet/>

      <section className="thirdsection pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingSweatShirt}
          products={sweatShirt}
          onProductClick={handleProductClick}
          title={"Top Men Sweat Shirts"}
        />
      </section>


      <section className="thirdsection  pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopWomenSweatShirt}
          products={topWomenSweatShirt}
          onProductClick={handleProductClick}
          title={"Top Women Sweatshirts"}
        />
      </section>

      <section className="thirdsection  pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopKidsShirt}
          products={topKidsShirt}
          onProductClick={handleProductClick}
          title={"Top Kids Sweatshirts"}
        />
      </section>

      <section className="secondsection">
        <div className="secondsection_image max-md:hidden">
          <img src="/image/ban6.png" alt="" />
        </div>
        <div className="secondsection_image md:hidden">
          <img src="/image/ban7.png" alt="" />
        </div>
      </section>

      <section className="firstsection max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopProducts}
          products={topProducts}
          onProductClick={handleProductClick}
          title={"Top Men T-Shirt"}
        />
      </section>

      {/*   <section className="thirdsection mt-1 mb-1 max-sm:!px-1 max-sm:py-2">
      
     
        <ProductList
          loading={loadingTopProducts}
          products={topProductsMan}
          onProductClick={handleProductClick} 
          title={'Top Men'}
        />
     
      </section> */}

      {/* Fourth Section */}

      <section className="thirdsection  pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopWomenTshirt}
          products={topWomenTshirt}
          onProductClick={handleProductClick}
          title={"Top Women T-Shirts"}
        />
      </section>

      <section className="thirdsection pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopKids}
          products={topProductsKids}
          onProductClick={handleProductClick}
          title={"Top Kids Thirt"}
        />
      </section>

      <section className="thirdsection  pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingHoodies}
          products={topProductsHoodies}
          onProductClick={handleProductClick}
          title={"Top Men Hoodies"}
        />
      </section>

      <section className="thirdsection pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopWomenHoodies}
          products={topWomenHoodies}
          onProductClick={handleProductClick}
          title={"Top Women Hoodies"}
        />
      </section>

      <section className="thirdsection pt-1 max-sm:!px-1 max-sm:py-2">
        <ProductList
          loading={loadingTopKidsHoodies}
          products={topKidsHoodies}
          onProductClick={handleProductClick}
          title={"Top Kids Hoodies"}
        />
      </section>

   {/*    <Newsletter /> */}
    </>
  );
};

export default Home;
